import fontResizer from "./common-components/fontResizer";
import pageLoader from "./common-components/pageLoader";
import landscapeOff from "./common-components/landscapeOff";
import stickyHeader from "./common-components/stickyHeader";
import svgConvert from "./common-components/svgConvert";
import navigationSlide from "./common-components/navigationSlide";
import animateObserver from "./common-components/animateObserver";
import dropdownTabs from "./common-components/dropdownTabs";
import navigationAccordion from "./common-components/navigationAccordion";
import selectTo from "./common-components/selectTo";
import heroLoadAnimation from "./common-components/heroLoadAnimation";
import telephoneFlag from "./common-components/telephoneFlag";
import accordion from "./pages-components/accordions";
import customHoverItems from "./pages-components/customhoveritem";
import inViewObserver from "./common-components/inViewObserver";
import searchPopup from "./common-components/search-popup";
import btnColorChange from "./common-components/btnColorChange";
import quoteFormPopup from "./common-components/quoteFormPopup";





window.addEventListener("load", function () {
  pageLoader(animateObserver);
  if (window.innerWidth > 1199) {
    fontResizer();
  }
  // Initialize Fancybox after page load
  Fancybox.bind("[data-fancybox]", {
    // Optional: custom options
    trapFocus: true,
    autoFocus: true,
    closeButton: "outside",
    Panzoom: false, // ⛔ disable pan/zoom completely
    dragToClose: false, // ⛔ disable grab & drag close
    swipeToClose: false, // ⛔ mobile drag
  });
});



landscapeOff();
stickyHeader();
svgConvert();
navigationSlide();
dropdownTabs();
navigationAccordion();
selectTo();
heroLoadAnimation();
telephoneFlag();
accordion();
customHoverItems();
inViewObserver();
searchPopup();
btnColorChange();
quoteFormPopup();

// clipPathImgObserver();
// -------------------- Above functions might be common for all website --------------------------

